import React, { Component, PropTypes } from 'react';
import { cond, equals, always, merge, propOr, pathOr, identity } from 'ramda';
import debounce from 'lodash.debounce';
import injectSheet from 'react-jss';
import {
  TextField,
  Divider,
} from 'material-ui';
import Select from 'react-select';

import { countries } from '../../utils/select-fields';
import Filter from './filter-partnerFinder';
import { getGeoLocation } from '../../utils/address';
import SearchForCompType from './search-widgets/search-for-company-type';
import SearchLocation from './search-widgets/search-location';
import SearchCheckbox from './search-widgets/search-checkbox';
import logoGlobeSrc from '../../../www/images/tourconnect-logo-globe.svg';

class SearchWidget extends Component {
  constructor(props) {
    super(props);
    const searchParams = {
      tabIndex: 0,
      country: undefined,
      city: undefined,
      latitude: undefined,
      longitude: undefined,
      companyType: undefined,
      segments: [],
      businessTypes: [], // only for nonaccom suppliers and contractors and others
      propertyTypes: [], // only for accom supliers
      destinationsSold: [],
      productType: [],
      page: undefined,
      companyOrLocationName: undefined,
      isForPremiumUser: false,
      buyerClientsFrom: '',
    };
    this.state = this.populateState(props, searchParams);
  }

  componentWillReceiveProps(props) {
    this.setState(this.populateState(props, this.state.searchParams));
  }

  populateState = (props, searchParams) => {
    let originalSearchParams = {};
    if (Object.keys(props.partnerFinder.searchParams).length) {
      originalSearchParams = Object.assign({}, searchParams, props.partnerFinder.searchParams);
    } else {
      const oppositeTypeOfSearcher = props.user.user.type === 'Contractor' ? 'Supplier' : 'Contractor';
      const companyType = searchParams.companyType || oppositeTypeOfSearcher;
      originalSearchParams.companyType = companyType;
      if (companyType === 'Contractor') {
        originalSearchParams.tabIndex = 0;
      } else if (companyType === 'DMOs') {
        originalSearchParams.tabIndex = 0;
      } else if (companyType === 'TechAndServices') {
        originalSearchParams.tabIndex = 0;
      } else {
        originalSearchParams.tabIndex = 1;
      }
    }
    const state = this.hideOrShowExtraforProductType(searchParams.productType, props.filters, originalSearchParams);
    state.position = props.position;
    return state;
  };

  _getCamelCase = cond([
    [equals('Business Types'), always('businessTypes')],
    [equals('Product Types'), always('productType')],
    [equals('Segments'), always('segments')],
    [equals('Property Types'), always('propertyTypes')],
  ]);

  debounceCitySearch = debounce(() => this._getGeoLocationThenSearch(), 500);

  _handleRadioOrTabsChange = type => {
    const originalSearchParams = merge(this.state.searchParams, {
      companyType: type,
      businessTypes: [],
      productType: [],
      propertyTypes: [],
    });
    const { filters, searchParams } = this.hideOrShowExtraforProductType(this.state.searchParams.productType, this.state.filters, originalSearchParams);
    if (type === 'Contractor') {
      searchParams.country = '';
    } else {
      searchParams.buyerClientsFrom = '';
    }
    if (type !== 'Supplier') {
      // querys not included on other types of companies
      searchParams.ratesLoaded = 0;
      searchParams.city = '';
    }
    this.setState({ filters, searchParams }, () => {
      this._getGeoLocationThenSearch();
    });
  };

  _handleSearchChange = ({ field, value }) => {
    this.setState({ searchParams: { ...this.state.searchParams, [field]: value } }, () => {
      this._getGeoLocationThenSearch();
    });
  };

  _getGeoLocationThenSearch = (initialClick) => {
    const {
      searchParams: {
        country: countryState,
        isForMap,
        companyType,
        city: cityState,
      },
      searchParams,
    } = this.state;
    const {
      search,
      router: {
        push,
      },
    } = this.props;
    if (initialClick) {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'PartnerFinder',
          action: 'Initial Search Click',
        },
      });
    }
    const city = this.refs.city ? this.refs.city.getValue() : cityState;
    const country = (companyType === 'TechAndServices') ? '' : countryState;

    getGeoLocation({ city, country }, (address, geometry) => {
      const [longitude, latitude] = (() => {
        if ((city || country) && isForMap) return address.coordinates;
        return [undefined, undefined];
      })();
      const newSearchParams = {
        ...searchParams,
        city,
        longitude,
        latitude,
        bounds: geometry.viewport,
      };
      this.setState({
        searchParams: newSearchParams,
      }, () => {
        search(this.state.searchParams);
        push('/partner-finder/results');
      });
    });
  };

  itemsChecked = (filterName, itemsChecked) => {
    const originalSearchParams = this.state.searchParams;
    const originalFilters = this.state.filters;
    let filters = originalFilters;
    let searchParams = Object.assign({}, originalSearchParams);
    if (filterName === 'productType') {
      const obj = this.hideOrShowExtraforProductType(itemsChecked, originalFilters, originalSearchParams);
      filters = obj.filters;
      searchParams = obj.searchParams;
    }
    if (filterName === 'country') {
      if (this.state.searchParams.companyType === 'Supplier') {
        searchParams.country = itemsChecked;
        searchParams.destinationsSold = [];
      } else if (this.state.searchParams.companyType === 'TechAndServices') {
        searchParams.country = '';
      } else {
        searchParams.country = '';
        searchParams.destinationsSold = [itemsChecked];
      }
    }
    searchParams[filterName] = itemsChecked;
    this.setState({
      filters,
      searchParams,
    }, () => {
      this._getGeoLocationThenSearch();
    });
  };

  hideOrShowExtraforProductType = (productType, oldFilters, searchParams) => {
    const filters = identity(oldFilters);
    filters.Supplier[1].hide = productType ? productType.indexOf('Accommodation') === -1 || productType.length === 2 : true;
    filters.Supplier[2].hide = productType ? productType.indexOf('Non-Accommodation') === -1 || productType.length === 2 : true;
    searchParams.propertyTypes = filters.Supplier[1].hide ? [] : searchParams.propertyTypes;
    if (searchParams.companyType === 'Non-Accommodation') {
      searchParams.businessTypes = filters.Supplier[2].hide ? [] : searchParams.businessTypes;
    }
    return {
      filters,
      searchParams,
    };
  };
  handleOnToggle = (toggleType) => () => {
    const { searchParams } = this.state;
    searchParams[toggleType] = searchParams[toggleType] ? 0 : 1;
    this.setState({ searchParams }, () => this._getGeoLocationThenSearch());
  };
  render() {
    const { searchParams, searchParams: { companyType: selectedCompanyType } } = this.state;
    const { classes: css } = this.props;
    const stylesLeftNav = {
      earth: { display: 'none' },
      selectField: { width: '90%', marginLeft: '15px' },
      list: { textAlign: 'left', display: 'block' },
      listItem: {},
      primaryText: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
                    fontSize: '12px', color: '#000', textTransform: 'uppercase', position: 'relative', top: '10px' },
      nestedPrimaryText: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
                    fontSize: '12px', marginLeft: '-20px', color: 'rgba(0, 0, 0, 0.54)' },
      nestedListItem: { marginLeft: '0px', paddingBottom: '0px' },
      secondaryText: { fontSize: '12px' },
      labelMenuStyle: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif", fontSize: '14px' },
      infoIcon: { width: '24px', height: '24px', fontSize: '16px', padding: '0', marginTop: '10px', marginRight: '5px', float: 'right' },
      checkbox: { },
    };

    const { styles, classes } = (() => {
      return {
        styles: stylesLeftNav,
        classes: {
          selectFieldContainer: 'select-field-container-left-nav',
          labelText: 'label-text-left-nav',
        },
      };
    })();

    const citySearchText = (
      <div style={{ marginTop: '-25px' }}>
        <TextField
          style={{
            fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
            fontSize: '14px',
            textAlign: 'left',
            width: '90%',
            display: 'block',
            margin: '0 0 10px 15px',
          }}
          ref="city"
          floatingLabelText="City / Region / Province"
          onKeyUp={this.debounceCitySearch}
          defaultValue={searchParams.city}
          hintText="City / Region / Province"
        />
      </div>
    );
    let contractorFilters;
    let supplierFilters;
    let dmoFilters;
    let otherFilters;
    let filters;

    if (this.state.filters) {
      const genericFilter = (index, filterNameCamelCase, filter) => {
        return (
          <Filter {...this.props}
            key={index}
            filterNameCamelCase={filterNameCamelCase}
            filterItemsSelected={searchParams[filterNameCamelCase] || []}
            filterStyles={styles}
            filterName={filter.filterName}
            filterList={filter.filterList}
            iconClassName={filter.filterIcon}
            onCheckFunction={this.itemsChecked}
          />
        );
      };
      contractorFilters = this.state.filters.Contractor.map((filter, index) => {
        const filterNameCamelCase = this._getCamelCase(filter.filterName);
        return genericFilter(index, filterNameCamelCase, filter);
      });
      dmoFilters = this.state.filters.DMOs.map((filter, index) => {
        const filterNameCamelCase = this._getCamelCase(filter.filterName);
        return genericFilter(index, filterNameCamelCase, filter);
      });
      otherFilters = this.state.filters.Other.map((filter, index) => {
        const filterNameCamelCase = this._getCamelCase(filter.filterName);
        return genericFilter(index, filterNameCamelCase, filter);
      });
      supplierFilters = this.state.filters.Supplier.map((filter, index) => {
        const filterNameCamelCase = this._getCamelCase(filter.filterName);
        const shouldReallyHide = filter.hide && !(searchParams[filterNameCamelCase] && searchParams[filterNameCamelCase].length);
        if (!shouldReallyHide) return genericFilter(index, filterNameCamelCase, filter);
      });
    }

    if (selectedCompanyType === 'Supplier') filters = supplierFilters;
    else if (selectedCompanyType === 'DMOs') filters = dmoFilters;
    else if (selectedCompanyType === 'TechAndServices') filters = otherFilters;
    else filters = contractorFilters;

    return (
      <div style={{ width: '100%' }}>
        <SearchForCompType
          companyType={selectedCompanyType}
          onChange={this._handleRadioOrTabsChange}
        />
        <Divider />
        <div style={styles.tab}>
        { selectedCompanyType === 'TechAndServices' ? undefined : <SearchLocation
          companyType={selectedCompanyType}
          searcherCompanyType={this.props.user.user.type}
          onChange={(country) => this._handleSearchChange({
            field: selectedCompanyType === 'Contractor' ? 'destinationsSold' : 'country',
            value: selectedCompanyType === 'Contractor' ? [country] : country,
          })}
          value={{
            Supplier: propOr('', 'country', searchParams),
            Contractor: pathOr('', ['destinationsSold', 0], searchParams),
            DMOs: propOr('', 'country', searchParams),
          }[selectedCompanyType] || ''}
        />}
          {(selectedCompanyType === 'TechAndServices' || selectedCompanyType === 'Contractor') ? undefined : citySearchText}
          {selectedCompanyType === 'Contractor' ? <div className={css.section}>
            <Divider />
            <div className={css.upperCaseTitle}>Traveler Origin</div>
            <div className={css.questionTitle}>Clients are from:</div>
            <Select
              className={css.countrySelect}
              onChange={({ value: val }) => this._handleSearchChange({ field: 'buyerClientsFrom', value: val })}
              options={[{ value: '', label: 'Anywhere' }, ...countries]}
              value={searchParams.buyerClientsFrom}
              placeholder="Anywhere"
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div> : undefined}
          {selectedCompanyType === 'Contractor' ? <div className={css.section}>
            <Divider />
            <div className={css.upperCaseTitle}>Buyer / Agent Location</div>
            <div className={css.questionTitle}>Located in:</div>
            <Select
              className={css.countrySelect}
              onChange={({ value: val }) => this._handleSearchChange({ field: 'country', value: val })}
              options={[{ value: '', label: 'Anywhere' }, ...countries]}
              value={searchParams.country}
              placeholder="Anywhere"
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div> : undefined}
          <Divider />
          <div className="tc-filtered-content" style={{ marginTop: '10px' }}>
            <div
              aria-label="TourConnect Verified status is reserved for legitimate tourism organisations that have active B2B relationships."
              className="hint--top hint--medium"
              style={{ width: '100%' }}
            >
              <SearchCheckbox style={styles.checkbox}
                iconEl={<img
                  src={logoGlobeSrc}
                  style={{ height: '14px', margin: '12px 15px 0px 17px' }}
                />}
                label="TourConnect Verified"
                toggled={Boolean(searchParams.tourConnectVerified)}
                onToggle={this.handleOnToggle('tourConnectVerified')}
              />
            </div>
            <SearchCheckbox style={styles.checkbox} icon="tc-icon-verified_user" iconColor="#97E397" label="Industry Verified" toggled={Boolean(searchParams.industryVerified)} onToggle={this.handleOnToggle('industryVerified')} />
            <SearchCheckbox style={styles.checkbox} icon="tc-icon-photo" iconColor="#0080ff" label="Marketing Materials" labelSize="13px" toggled={Boolean(searchParams.hasMM)} onToggle={this.handleOnToggle('hasMM')} />
            <SearchCheckbox style={styles.checkbox} icon="tc-icon-update" iconColor="#7F00FF" label="Quick Responder" toggled={Boolean(searchParams.quickResponder)} onToggle={this.handleOnToggle('quickResponder')} />
            <SearchCheckbox style={styles.checkbox} icon="tc-icon-user-check" iconColor="rgba(0, 0, 0, 0.54)" label="Exclude Connected" toggled={Boolean(searchParams.excludeConnected)} onToggle={this.handleOnToggle('excludeConnected')} />
            {selectedCompanyType === 'Supplier' && <SearchCheckbox style={styles.checkbox} icon="tc-icon-description" iconColor="#ff7f00" label="Rates Loaded" toggled={Boolean(searchParams.ratesLoaded)} onToggle={ this.handleOnToggle('ratesLoaded')} />}
          </div>
          <br/>
          <Divider />
          {filters}
        </div>
      </div>
    );
  }

}

SearchWidget.propTypes = {
  classes: PropTypes.object,
  context: PropTypes.object,
  filters: PropTypes.object,
  partnerFinder: PropTypes.object,
  position: PropTypes.string,
  router: PropTypes.object,
  search: PropTypes.func,
  searchParams: PropTypes.object,
  user: PropTypes.object,
};

export default injectSheet({
  section: {
    margin: '10px 0 10px 0',
  },
  questionTitle: {
    margin: '5px 0 0 10px',
    color: 'black',
  },
  upperCaseTitle: {
    color: '#000',
    fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
    fontSize: '12px',
    fontWeight: '600',
    margin: '10px 0 0 15px',
    position: 'relative',
    textTransform: 'uppercase',
  },
  countrySelect: {
    margin: '5px 0 15px 15px',
    width: '90%',
    '& div': {
      borderLeft: 'none !important',
      borderRight: 'none !important',
      borderTop: 'none !important',
    },
  },
})(SearchWidget);



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/searchWidget-partnerFinder.jsx